import { encolar } from '@/lib/localStore'

export type ReportReliabilityKind = 'local_save_failed' | 'sync_retry' | 'sync_blocked'

export async function recordReportReliabilityEvent(params: {
  userId: string
  reportId?: string | null
  kind: ReportReliabilityKind
}): Promise<void> {
  if (!params.userId) return
  try {
    await encolar({
      usuarioId: params.userId,
      tabla: 'report_reliability_events',
      tipo: 'insert',
      datos: {
        id: crypto.randomUUID(),
        user_id: params.userId,
        report_id: params.reportId ?? null,
        event_kind: params.kind,
        created_at: new Date().toISOString(),
      },
    })
  } catch {
    // Measurement failures must not affect clinical report work.
  }
}
